/**
 * 费用预警（延伸需求 3.6 预算预警、3.3 重复报销）
 *
 * 页面本体在 `components/AlertBoard.tsx`，与合同预警共用。
 */

import { Card } from 'antd';
import { ExpenseAlertType, EXPENSE_ALERT_TYPE_LABELS, PermissionCode } from '@ilc/shared';
import { expenseApi } from '@/api/endpoints';
import { AlertBoard } from '@/components/AlertBoard';

export function ExpenseAlertsPage(): React.ReactElement {
  return (
    <AlertBoard
      title="费用预警"
      description="每日扫描预算执行情况与在办单据"
      alerts={(q) => expenseApi.alerts(q)}
      handle={(id, body) => expenseApi.handleAlert(id, body)}
      handlePermission={PermissionCode.EXPENSE_ALERT_HANDLE}
      typeOptions={Object.entries(EXPENSE_ALERT_TYPE_LABELS).map(([value, label]) => ({
        value,
        label,
      }))}
      footnote={
        <>
          <ul style={{ margin: 0, paddingLeft: 18, fontSize: 13 }}>
            <li>
              <strong>预算接近上限</strong>：执行率（已用 + 在途）达到提醒线，默认 80%。
              <em>阈值与「超了怎么办」都在租户配置里</em>（<code>budgetWarnPercent</code> /{' '}
              <code>budgetOverPolicy</code>），不是写死的。
            </li>
            <li>
              <strong>预算已超支</strong>：执行率超过 100%。与「接近上限」是<em>两条独立的预警</em>——
              超支出现时会新增一条，而不是把原来那条改成超支（否则列表里会看到"接近上限"却已经超了）。
            </li>
            <li>
              <strong>单据长期未处理</strong>：报销单提交超过 7 天仍在审批中。按天分桶，会一直提醒直到有人处理。
            </li>
          </ul>
          <Card size="small" style={{ marginTop: 12, background: '#fafafa' }}>
            <strong>为什么「已用」要把在途也算进去</strong>：只看已批准的话，预算在审批期间会显得很宽裕；
            等一批在途单同时批下来才发现超了，那时已经拦不住。
            <br />
            <strong>为什么默认只预警不拦截</strong>：与本平台「自动化只做风险标记、不跳过人工确认」的取向一致。
            预算数字本身可能滞后（在途单据、未批的调整），硬拦会挡住真实业务。
            要拦得由租户把 <code>budgetOverPolicy</code> 显式设为 <code>BLOCK</code>。
          </Card>
        </>
      }
    />
  );
}

export default ExpenseAlertsPage;
